import React from "react";
import Banner from "../components/Banner";
import CoinsTable from "../components/CoinsTable";
const Home = () => {
    return <>
        <Banner />
        <CoinsTable />
    </>
};
export default Home;